import styled from 'styled-components';

import { GenericDiv, GenericP } from 'commonStyles';

export const Copy = styled(GenericDiv)`
  top : ${(p)=>p.$top || 'auto'};
	right : ${(p)=>p.right || 'auto'};
	left : ${(p)=>p.left || 'auto'};
	color: ${(props) => props.color ? props.color : '#374B63'};
	border-left: 1px solid #ffffff;
`;
